import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetContent from "../../common/FacetContent";
import ConjunctiveFacet from "./ConjunctiveFacet";
import DisjunctiveFacet from "./DisjunctiveFacet";

var Facet = /*#__PURE__*/function (_Component) {
  _inherits(Facet, _Component);

  var _super = _createSuper(Facet);

  function Facet() {
    _classCallCheck(this, Facet);

    return _super.apply(this, arguments);
  }

  _createClass(Facet, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(FacetContent, {
        displayFreeCheckbox: this.props.displayFreeCheckbox,
        facet: this.props.facet,
        facetBar: this.props.facetBar,
        facetType: this.props.facet.get('type'),
        filters: this.props.filters,
        hiddenFilters: this.props.hiddenFilters,
        itemFactory: this.props.itemFactory,
        onFacetProductClick: this.props.onFacetProductClick,
        perspective: this.props.perspective,
        sortingLogicForCategory: this.props.sortingLogicForCategory,
        stateChangeRequested: this.props.stateChangeRequested,
        FacetComponent: this.props.FacetComponent,
        ConjunctiveFacet: ConjunctiveFacet,
        DisjunctiveFacet: DisjunctiveFacet
      });
    }
  }]);

  return Facet;
}(Component);

_defineProperty(Facet, "propTypes", {
  displayFreeCheckbox: PropTypes.bool,
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  facetBar: PropTypes.oneOf(['top', 'side']),
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  sortingLogicForCategory: PropTypes.string,
  stateChangeRequested: PropTypes.func.isRequired,
  FacetComponent: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
});

export { Facet as default };